import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import EndWrapSequencerNode from "models/audioEditor/sequencerNodes/EndWrapSequencerNode";

const CLASSNAME = "EndMuteWrapSequencerNode";

const EndMuteWrapSequencerNode = EndWrapSequencerNode.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        EndWrapSequencerNode.apply(this, [attributes, options]);
    },

    getConstructor: function(){
        return EndMuteWrapSequencerNode;
    },

    cloneJSON: function(){
        const objJson = EndWrapSequencerNode.prototype.cloneJSON.call(this);
        objJson.type = EndMuteWrapSequencerNode.CLASSNAME;
        objJson.targetTrackId = this.get("targetTrackId") || null;
        return objJson;
    },

    getSerializedData: function(){
        return EndWrapSequencerNode.prototype.getSerializedData.call(this);
    },

    restoreFromSerializedData: function(serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray){
        return EndWrapSequencerNode.prototype.restoreFromSerializedData.call(this, serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray);
    },

    afterAllInstancesCreatedFromSerializedData: function(serializedData, sequencerNodeCidToSequencerNodeMap){
        EndWrapSequencerNode.prototype.afterAllInstancesCreatedFromSerializedData.call(this, serializedData, sequencerNodeCidToSequencerNodeMap);
    },

    isModifyingAudioBufferFromWrappedNodeAudioSegment: function(){
        return false;
    },

    isCreatingAudioSegmentThatWillBeMergeWithWrappedNodeAudioSegment: function(){
        return false;
    },

    setTargetTrackId: function(targetTrackId){
        this.set("targetTrackId", targetTrackId || null);
        if (this.getStartWrapSequencerNode()) {
            this.getStartWrapSequencerNode().set("targetTrackId", targetTrackId || null);
        }
    },

    getTargetTrackId: function(){
        return this.get("targetTrackId") || null;
    },

    getContent: function(){
        return `<span style="display: inline-flex;align-items: center;"><span class="icon soundwave-drag-indicator drag_icon" style="font-size: 70%"></span><span class="icon pe-7s-mute mute_icon"></span></span>`;
    }
});

EndMuteWrapSequencerNode.CLASSNAME = CLASSNAME;

export default EndMuteWrapSequencerNode;
